import themeColors from '../consts/themeColors';
import themeStyle from '../consts/themeStyle';
import {setTheme} from '../state/slice/global';
import {dispatch} from '../state/store';
import uaUtils from '../utils/uaUtils';
import storageService from './storageService';
import {userBrowserService} from './userBrowserService';

const updateClass = (el, theme) => {
    el.classList.toggle(themeStyle.DARK, theme === themeStyle.DARK);
    el.classList.toggle(themeStyle.LIGHT, theme === themeStyle.LIGHT);
};

const updateBg = (el, theme) => {
    const backgroundColor = themeColors[theme];

    el.style.backgroundColor = backgroundColor;
    document.body.style.backgroundColor = backgroundColor;
};

const updateThemeColor = (theme) => {
    const isIos = uaUtils.getIsIOS();
    const isPWA = userBrowserService.getIsPWA();

    if (isIos && !isPWA) return;

    const metaTag = document.querySelector('meta[name="theme-color"]');

    if (metaTag) {
        metaTag.setAttribute('content', themeColors[theme]);
    }
};

const getSelectedThemeColor = () => {
    const theme = storageService.getThemeFromLocalStorage();

    return themeColors[theme] || themeColors.LIGHT;
};

/*
  shouldStateUpdate - allows changing the theme without updating the state with the global theme. 
  Thus, we can apply a temporary theme (overriddenTheme), and after that, 
  easily switch back to the global value since it remains unchanged.
 */
const applyTheme = (theme, shouldStateUpdate = true) => {
    const root = document.documentElement;

    updateBg(root, theme);
    updateThemeColor(theme);
    updateClass(root, theme);

    if (shouldStateUpdate) {
        dispatch(setTheme(theme));
    }
};

export default {
    applyTheme,
    getSelectedThemeColor,
};
